import API from "@/lib/API";

export const orderRequestService = {
  getOrderRequests: async () => {
    try {
      const response = await API.get('/inventory/order-requests');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateOrderRequest: async (id, field, value) => {
    try {
      const response = await API.put(`/inventory/order-requests/${id}`, { field, value });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  receiveInStore: async (id) => {
    try {
      const response = await API.patch(`/inventory/order-requests/${id}/receive`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  dispatchOrderRequest: async (id, dispatch_details, store_id) => {
    try {
      const response = await API.patch(`/inventory/order-requests/${id}/dispatch`, { dispatch_details, store_id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
